import { type CreateBrandInputType } from '@shelflix/schemas/brand/create';
import { create } from 'zustand';

interface BrandFormStore {
  formData: Partial<CreateBrandInputType>;
  setFormData: (data: Partial<CreateBrandInputType>) => void;
  resetForm: () => void;
}

export const useBrandFormStore = create<BrandFormStore>((set) => ({
  formData: {}, // Initialize with an empty relatedBrands array
  setFormData: (data) => set((state) => ({ formData: { ...state.formData, ...data } })),
  resetForm: () => set({ formData: {} }),
}));
